export default __webpack_public_path__ + "static/media/download.faad3e8b.svg";